// WhatsApp-style relative time formatter for chat-list rows.
// Rules (per user spec, Feb-14-2026 session-32):
//   • < 1 min       → "now"
//   • same day <1h  → "N min"     (e.g. "5 min", "45 min")
//   • same day ≥1h  → "N hr"      (e.g. "2 hr", "8 hr")
//   • previous day  → "Yesterday"
//   • older         → "D/M/YYYY"  (e.g. "8/11/2025")
// Always uses IST (Asia/Kolkata) so a 23:55 IST timestamp on Feb-13 stays
// "Feb-13" even if the user's browser is in a different timezone.
export default function formatChatTime(iso) {
  if (!iso) return '';
  const norm = typeof iso === 'string' && !/[Zz]|[+-]\d\d:?\d\d$/.test(iso) ? iso + 'Z' : iso;
  const then = new Date(norm);
  if (isNaN(then.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - then.getTime();
  const diffMin = Math.floor(diffMs / 60000);

  if (diffMin < 1) return 'now';
  if (diffMin < 60) return `${diffMin} min`;

  // Compare calendar dates in IST — WhatsApp treats "yesterday" as previous
  // local calendar day, not last 24 hours.
  const istOpts = { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' };
  const fmt = new Intl.DateTimeFormat('en-CA', istOpts); // en-CA gives YYYY-MM-DD
  const thenKey = fmt.format(then);
  const nowKey = fmt.format(now);

  if (thenKey === nowKey) {
    const hr = Math.floor(diffMin / 60);
    return `${hr} hr`;
  }

  // Yesterday?
  const yesterday = new Date(now.getTime() - 86400000);
  const yestKey = fmt.format(yesterday);
  if (thenKey === yestKey) return 'Yesterday';

  // Older — dd/mm/yyyy in IST
  const dd = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'numeric', year: 'numeric' })
    .format(then);
  return dd; // en-GB gives "d/m/yyyy"
}
